import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PortfolioPage } from '@/domains/credit';

// El router coacciona un `?credit=` numérico a number: se acepta y se normaliza a texto.
const searchSchema = z.object({
    credit: z.union([z.string(), z.number()]).transform(String).optional().catch(undefined),
});

export type PortfolioSearch = z.infer<typeof searchSchema>;

/** Deep link `?credit=<id>`: abre ese crédito en la ficha. Lo que no valida se ignora. */
export function parsePortfolioSearch(search: Record<string, unknown>): PortfolioSearch {
    const parsed = searchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
}

// Ruta estática: gana sobre la dinámica hermana `$section`, que sigue cubriendo el resto.
export const Route = createFileRoute('/_backoffice/credit/portfolio')({
    validateSearch: parsePortfolioSearch,
    component: CreditPortfolio,
});

function CreditPortfolio() {
    const { credit } = Route.useSearch();
    return <PortfolioPage credit={credit} />;
}
